import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Beaker } from 'lucide-react';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation();

  const navLinks: { path: string; label: string }[] = [
    // 暂时移除个人中心，因为该功能尚未实现
  ];

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      {/* 打印时隐藏站点导航，避免覆盖内容 */}
      <nav className="fixed top-0 left-0 right-0 bg-[#3A7D78]/95 z-50 shadow-lg print:hidden">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center gap-2">
              <Link to="/" className="flex items-center gap-2 text-xl font-bold">
                <Beaker className="h-8 w-8 text-[#F5B6C1]" />
                <span className="text-white">人格向量实验室</span>
              </Link>
            </div>
            
            <div className="flex space-x-4">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`px-3 py-2 rounded-md text-sm font-medium transition-colors
                    ${location.pathname === link.path 
                      ? 'bg-[#F5B6C1] text-white'
                      : 'text-white/80 hover:text-white hover:bg-[#F5B6C1]/50'
                    }`}
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </nav>

      {/* 打印时去掉顶部间距 */}
      <main className="flex-grow pt-16 print:pt-0">
        {children}
      </main>

      {/* 屏幕页脚：打印时隐藏 */}
      <footer className="bg-[#3A7D78] text-white/80 py-6 print:hidden">
        <div className="container mx-auto px-4 text-center">
          <p>© {new Date().getFullYear()} 人格向量实验室. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default Layout;